module.exports = __webpack_public_path__ + "8ca86d.png";